module.exports = __webpack_public_path__ + "img/NU.fc733d3c.png";